import React from "react";
import "./OutOfHomeFinalCta.css";
import { useTranslation } from "react-i18next";

const OutOfHomeFinalCta = ({ openModal }) => {
  const { t } = useTranslation();

  return (
    <div className="oohs-section oohs-section--flat-bottom">
      <div className="oohs-section-inner ooh-final-cta-inner">
        <h2 className="oohs-title">{t("outOfHomePage.finalCta.title")}</h2>
        <p className="oohs-subtitle" style={{ marginBottom: "0" }}>
          {t("outOfHomePage.finalCta.subtitle")}
        </p>
        <button type="button" className="oohs-cta-btn" onClick={openModal}>
          {t("outOfHomePage.finalCta.button")}
        </button>
      </div>
    </div>
  );
};

export default OutOfHomeFinalCta;
